// rating.js — die zwei Arten von Sternen als Vorlagen (Markup aus src/shared/rating.js, Zwilling lib/rating.js für die
// öffentliche Platzseite) und die Erklärung „Zwei Arten von Sternen“ als Dialog. Anzeigen bauen die Sterne nie selbst.
import { unsafeHtml, escHtml } from '../core/h.js';
import { t, fmtNum } from '../../shared/i18n.js';
import { userRatingHtml, classHtml, ratingExplainHtml } from '../../shared/rating.js';
import { openDialog } from './dialog.js';

const base = () => ({ t, esc: escHtml, fmt: (n) => fmtNum(n, { maximumFractionDigits: 1 }) });
/** Bewertung der Camper (leer ohne Bewertungen). o: { size, countText, btn } wie in src/shared/rating.js. */
export const userRatingTpl = (s, o = {}) => unsafeHtml(userRatingHtml(s, { ...base(), ...o }));
/** Klassifizierung wie bei Hotels (leer ohne ganze 1–5). */
export const classTpl = (n, o = {}) => unsafeHtml(classHtml(n, { ...base(), ...o }));
/** Knopf-Attribut, das die Erklärung öffnet (Klick-Handler: openRatingInfo). */
export const RATING_INFO = 'data-rating-info aria-haspopup="dialog"';
/** Erklärung „Zwei Arten von Sternen“; spot liefert die Beispielwerte (eigene Bewertung und Klassifizierung). */
export function openRatingInfo(spot) {
  return openDialog({ title: t('ui.rate_explain'), body: unsafeHtml(ratingExplainHtml({ ...base(), spot })), actions: [{ label: t('ui.close'), primary: true }] });
}
